$(document).on('turbo:load', function() {
  var spinnerHtml = " <i class=\"fa fa-spinner fa-spin\"></i>";
  if($(".member.administration").length == 0) return;

  $("a.sync-organizations").on('click', function(e) {
    e.preventDefault();
    const $link = $(this);
    const url = $link.attr('href');
    
    // Show spinner and hide messages
    $link.html($link.html() + spinnerHtml);
    $('.sync-org-success, .sync-org-error').addClass('d-none');
    
    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      $link.html($link.html().replace(spinnerHtml, ''));
      
      if (response.ok) {
        console.log('Sync started successfully');
        $('.sync-org-success').removeClass('d-none').show();
        $('.sync-org-error').addClass('d-none');
      } else {
        console.error('Sync failed with status:', response.status);
        $('.sync-org-error').removeClass('d-none').show();
        $('.sync-org-success').addClass('d-none');
      }
    })
    .catch(error => {
      $link.html($link.html().replace(spinnerHtml, ''));
      $('.sync-org-error').removeClass('d-none').show();
      $('.sync-org-success').addClass('d-none');
      console.error('Sync error:', error);
    });
  });
});